import { EXTRA_INFO_PRIORITY_FIELDS } from "../../../shared/constants";
import { mapNameToIdValue } from "../../../shared/db/tags-labels-selectors";
import { isSpecialType } from "./extraInfo.utils";

 export const sortLabels = (labelsToSort: [string, string | object][], infos?: any) => {
    return labelsToSort.sort((a, b) => {
      const priorityMap = new Map(
        EXTRA_INFO_PRIORITY_FIELDS.map((name, idx) => [name, idx] as const)
      );

      // Categories first
      const isACategory = isSpecialType(a[1], "isCategory");
      const isBCategory = isSpecialType(b[1], "isCategory");

      if (isACategory && a[0].toLowerCase() === "vehicle") return -1;
      if (isBCategory && b[0].toLowerCase() === "vehicle") return 1;
      if (isACategory && !isBCategory) return -1;
      if (!isACategory && isBCategory) return 1;

      // Then by 'order' from infos if available
      if (infos) {
        const labelIdA = mapNameToIdValue(a[0], infos);
        const labelIdB = mapNameToIdValue(b[0], infos);

        const orderA = infos[labelIdA]?.details?.order;
        const orderB = infos[labelIdB]?.details?.order;

        // Compare based on 'order' if both have it defined
        if (orderA !== undefined && orderB !== undefined && orderA !== orderB) {
          return orderA - orderB;
        }
      }

      // Then by priority list
      if (!isACategory && !isBCategory) {
        const aIdx = priorityMap.get(a[0]) ?? EXTRA_INFO_PRIORITY_FIELDS.length + 1;
        const bIdx = priorityMap.get(b[0]) ?? EXTRA_INFO_PRIORITY_FIELDS.length + 1;
        if (aIdx !== bIdx) return aIdx - bIdx;
      }

      // Finally alphabetically
      return a[0].localeCompare(b[0]);
    });
  };